import mixpanel from 'mixpanel-browser';

export function useMixpanel() {
  const trackMixpanel = (event: string, properties?: Record<string, unknown>) => {
    mixpanel.track(event, properties);
  };

  return { mixpanel, trackMixpanel };
}
